import React, { Component } from 'react';
import '../css/App.css'
import OfficeBox from './OfficeBox'
import {getPartyColorForOffice} from '../utils/helper'

class OfficeResultList extends Component{
   
    render(){
       const {leftPart, rightPart, topOfficeResult, electionCode, colors} = this.props
      // console.log(leftPart.resData)
       return(
            <div className='col' >
                {(colors) && 
                <div className='row'>
                    <div className={((window.innerWidth >= 768) ? "col-md-12":"fullWidth")+" leftCol rightCol"}>
                    { topOfficeResult && (electionCode=='G'|| electionCode=='S') && <OfficeBox appendPartyCodeToCandidateName={this.props.appendPartyCodeToCandidateName} colorSet={getPartyColorForOffice(colors, topOfficeResult.ElectionData, electionCode)} topResult={true} dataList={topOfficeResult}/>}
                    { topOfficeResult && electionCode=='P' && <OfficeBox appendPartyCodeToCandidateName={this.props.appendPartyCodeToCandidateName} colorSet={getPartyColorForOffice(colors, topOfficeResult.ElectionData, electionCode)} topResult={true} dataList={topOfficeResult}/>}
                    </div>
               
                    <div className={"leftCol" + ((window.innerWidth >= 768) ? " col-md-6":" fullWidth")} >
                        {(electionCode=='G'|| electionCode=='S') && leftPart.resData && leftPart.resData.map(officeResult => (
                            <OfficeBox appendPartyCodeToCandidateName={this.props.appendPartyCodeToCandidateName} colorSet={getPartyColorForOffice(colors, officeResult.ElectionData, electionCode)} key={officeResult.ContestNumber} topResult={false} dataList={officeResult}/>
                        ))}
                        {electionCode=='P' && leftPart.resData && leftPart.resData.map(officeResult => (
                            <OfficeBox appendPartyCodeToCandidateName={this.props.appendPartyCodeToCandidateName} colorSet={getPartyColorForOffice(colors, officeResult.ElectionData, electionCode)} key={officeResult.ContestNumber} topResult={false} dataList={officeResult}/>
                        ))}
                    </div>
                    <div className="rightCol col-md-6" >
                        {(electionCode=='G'|| electionCode=='S') && rightPart.resData && rightPart.resData.map(officeResult => (
                            <OfficeBox appendPartyCodeToCandidateName={this.props.appendPartyCodeToCandidateName} colorSet={getPartyColorForOffice(colors, officeResult.ElectionData, electionCode)} key={officeResult.ContestNumber} topResult={false} dataList={officeResult}/>
                        ))}
                        {electionCode=='P' && rightPart.resData && rightPart.resData.map(officeResult => (
                            <OfficeBox appendPartyCodeToCandidateName={this.props.appendPartyCodeToCandidateName} colorSet={getPartyColorForOffice(colors, officeResult.ElectionData, electionCode)} key={officeResult.ContestNumber} topResult={false} dataList={officeResult}/>
                        ))}
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default OfficeResultList


// WEBPACK FOOTER //
// ./src/components/OfficeResultList.js